const notificationsMixin = {
  methods: {
    notifySuccess(msg) {
      this._addSnackbar('success', msg);
    },
    notifyDanger(msg) {
      this._addSnackbar('danger', msg);
    },
    notify(msg) {
      this._addSnackbar(null, msg);
    },
    _addSnackbar(type, msg) {
      let bgColor;
      switch (type) {
        case 'success':
          bgColor = '#31B404';
          break;
        case 'danger':
          bgColor = '#E41E1E';
          break;
        default:
          bgColor = '#333';
      }

      const distFromBottom = 50;
      const duration = 2.5;

      let container = document.querySelector('#snackbar-container');
      if (!container) {
        container = document.createElement('div');
        container.id = 'snackbar-container';

        // should move all of these styles to a global style sheet
        container.setAttribute(
          'style',
          `
                    position: fixed;
                    bottom: ${distFromBottom}px;
                    min-width: 250px;
                    left: 50%;
                    transform: translateX(-50%);
                    display: flex;
                    flex-direction: column; 
                    flex-direction: reverse;
                    z-index: 10000;

                `,
        );
        document.body.appendChild(container);

        const style = document.createElement('style');
        style.id = 'snackbar-style';
        style.innerHTML = `
                    .snackbar {
                        visibility: hidden; 
                        min-width: 500px; 
                        color: #fff; 
                        font-size: 15px;
                        text-align: center; 
                        border-radius: 4px; 
                        padding: 15px; 
                        margin-top: 5px;
                        z-index: 10001; 
                    }
                    
                    .snackbar.show {
                        visibility: visible; 
                        -webkit-animation: fadein 0.5s, fadeout 0.5s ${duration}s;
                        animation: fadein 0.5s, fadeout 0.5s ${duration}s;
                    }
                    
                    /* Animations to fade the snackbar in and out */
                    @-webkit-keyframes fadein {
                        from {bottom: 0; opacity: 0;}
                        to {bottom: ${distFromBottom}px; opacity: 1;}
                    }
                    
                    @keyframes fadein {
                        from {bottom: 0; opacity: 0;}
                        to {bottom: ${distFromBottom}px; opacity: 1;}
                    }
                    
                    @-webkit-keyframes fadeout {
                        from {bottom: ${distFromBottom}px; opacity: 1;}
                        to {bottom: 0; opacity: 0;}
                    }
                    
                    @keyframes fadeout {
                        from {bottom: ${distFromBottom}px; opacity: 1;}
                        to {bottom: 0; opacity: 0;}
                    }
                `;
        document.body.appendChild(style);
      }

      const el = document.createElement('div');
      el.classList.add('snackbar');
      el.classList.add('show');
      el.style.backgroundColor = bgColor;

      el.innerHTML = msg;
      container.appendChild(el);
      setTimeout(
        () => {
          container.removeChild(el);
        },
        duration * 1000 + 500,
      );
    },
  },
};

export { notificationsMixin };
